import React,  { useEffect, useState } from 'react';
import {InputGroup, Form, Button} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

// A felhasználó nevének megadása. Kötelező: amíg nincs név, nem lehet továbblépni.
// (Ezen a néven szólítjuk meg; a számlára a számlázási adatoknál megadott név kerül.)
export default function NevMegadas(props) {
  const [form_nev_validated, setForm_nev_validated] = useState(false);
  const [nev, setNev] = useState('');

  useEffect(() => {
    setNev(props.nev || '')
  }, [props.nev]);

  function onSubmit_nev_megadasa(event){
    event.preventDefault();
    event.stopPropagation();
    if (props.getCommInProgress()){
      return;
    }
    const form = event.currentTarget;
    if (form.checkValidity() === false || nev.trim() === '') {
        // rossz név
        setForm_nev_validated(true);
        return;
    }
    props.onSave(nev.trim());
  }

  return (
    <div>
    <br />
    <br />
    <div className="utasitas">Kérjük, adja meg nevét!</div>
    <div className="utasitas-megjegyzes" >(Az Ön kíséretével érkező gyermekek adatait később kell megadnia.)</div>
    <br />
    <Form noValidate validated={form_nev_validated} onSubmit={onSubmit_nev_megadasa}  >
        <Form.Group className="mb-3" controlId="formNevMegadas">
            <InputGroup hasValidation={true}>
                <InputGroup.Text id="inputGroupPrepend"><FontAwesomeIcon icon="fa-id-card" size='2x' color="#609090" /></InputGroup.Text>
                <Form.Control type="text" placeholder="Név" value={nev} required maxLength={50} onChange={e => setNev(e.target.value)} />
                <Form.Control.Feedback type="invalid">A nevet kötelező megadni.</Form.Control.Feedback>
            </InputGroup>
        </Form.Group>
        <Button variant="primary" type="submit">Mentés</Button>
    </Form>
</div>
  )
}
